import request from '@/utils/request'
 
// 获取模板列表
export function getTemplates(data) {  
  data.lang = localStorage.getItem('lang') !=null ? localStorage.getItem('lang') : 'zh-CN'  
  return request({
    url: '/api/template/list',
    method: 'post',
    data
  })
}

//获取模板详情
export function getTemplateDetail(data) {  
  data.lang = localStorage.getItem('lang') !=null ? localStorage.getItem('lang') : 'zh-CN'  
  return request({
    url: '/api/template/detail',
    method: 'post',
    data
  })
}

//变量详情
export function getVarDetail(data) {  
  data.lang = localStorage.getItem('lang') !=null ? localStorage.getItem('lang') : 'zh-CN'  
  return request({
    url: '/api/template/vardetail',
    method: 'post',
    data
  })
}

//得到变量详情
export function vardetailbydevice(data) {  
  data.lang = localStorage.getItem('lang') !=null ? localStorage.getItem('lang') : 'zh-CN'  
  return request({
    url: '/api/template/vardetailbydevice',
    method: 'post',
    data
  })
}

//得到变量分组名称
export function vargroupdetailbydevice(data) {  
  data.lang = localStorage.getItem('lang') !=null ? localStorage.getItem('lang') : 'zh-CN'  
  return request({
    url: '/api/template/vargroupdetailbydevice',
    method: 'post',
    data
  })
}

 

//通过设备得从机详细
export function slavedetailbydevice(data) {  
  data.lang = localStorage.getItem('lang') !=null ? localStorage.getItem('lang') : 'zh-CN'  
  return request({
    url: '/api/template/slavedetailbydevice',
    method: 'post',
    data
  })
}





export function createTemplate(data) {
  data.lang = localStorage.getItem('lang') !=null ? localStorage.getItem('lang') : 'zh-CN'  
  return request({
    url: '/api/template/add',
    method: 'post',
    data
  })
}
  
export function updateTemplate(data) {
  data.lang = localStorage.getItem('lang') !=null ? localStorage.getItem('lang') : 'zh-CN'  
  return request({
    url: '/api/template/edit',
    method: 'post',
    data
  })
}
 
export function deleteTemplate(data) {
  data.lang = localStorage.getItem('lang') !=null ? localStorage.getItem('lang') : 'zh-CN'  
  return request({
    url: '/api/template/delete',
    method: 'post',
    data
  })
}

export function getSlavesByTemplate(data) {
  data.lang = localStorage.getItem('lang') !=null ? localStorage.getItem('lang') : 'zh-CN'  
  return request({
    url: '/api/slave/list',
    method: 'post',
    data
  })
}

export function createSlave(data) {
  data.lang = localStorage.getItem('lang') !=null ? localStorage.getItem('lang') : 'zh-CN'  
  return request({
    url: '/api/slave/add',
    method: 'post',
    data
  })
}

export function updateSlave(data) {
  data.lang = localStorage.getItem('lang') !=null ? localStorage.getItem('lang') : 'zh-CN'  
  return request({
    url: '/api/slave/edit',
    method: 'post',
    data
  })
}

export function deleteSlave(data) {
  data.lang = localStorage.getItem('lang') !=null ? localStorage.getItem('lang') : 'zh-CN'  
  return request({
    url: '/api/slave/delete',
    method: 'post',
    data
  })
}

export function getProtocols(data) {
  data.lang = localStorage.getItem('lang') !=null ? localStorage.getItem('lang') : 'zh-CN'  
  return request({
    url: '/api/slave/protocollist',
    method: 'post',
    data
  })
}

//通过模板得变量
export function getVariablesByTemplate(data) {  
  data.lang = localStorage.getItem('lang') !=null ? localStorage.getItem('lang') : 'zh-CN'  
  return request({
    url: '/api/variable/list',
    method: 'post',
    data
  })
}


export function updateVariableGroupSort(data) {  
  data.lang = localStorage.getItem('lang') !=null ? localStorage.getItem('lang') : 'zh-CN'  
  return request({
    url: '/api/variable/updatevariablegroupsort',
    method: 'post',
    data
  })
}




export function createVariable(data) {
  data.lang = localStorage.getItem('lang') !=null ? localStorage.getItem('lang') : 'zh-CN'  
  return request({
    url: '/api/variable/add',
    method: 'post',
    data
  })
}


export function createVariables(data) {
  data.lang = localStorage.getItem('lang') !=null ? localStorage.getItem('lang') : 'zh-CN'  
  return request({
    url: '/api/variable/adds',
    method: 'post',
    data
  })
}

//导出变量
export function exportVariablesByFile(data) {
  const formData = new FormData();

  if (data.slave_id) {
    formData.append('slave_id', data.slave_id);
  }
  if (data.template_id) {
    formData.append('template_id', data.template_id);
  }
  if (data.name) {
    formData.append('name', data.company_id);
  }
  formData.append('lang', localStorage.getItem('lang') !=null ? localStorage.getItem('lang') : 'zh-CN'  );

  return request({
    url: '/api/variable/export',
    method: 'post',
    data:formData,
    responseType: 'blob',
    headers: {
      'Content-Type': 'application/json' // 明确指定请求内容类型
    }
  })
}

//导入变量
export function importVariablesByFile(data) {
  const formData = new FormData();
  
  // 添加文件和其他参数到 FormData
  if (data.file) {
    formData.append('file', data.file);
  }
  if (data.slave_id) {
    formData.append('slave_id', data.slave_id);
  }
  if (data.template_id) {
    formData.append('template_id', data.template_id);
  }
  if (data.company_id) {
    formData.append('company_id', data.company_id);
  }

  formData.append('lang', localStorage.getItem('lang') !=null ? localStorage.getItem('lang') : 'zh-CN'  );
   
  

  return request({
    url: '/api/variable/import',
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data' // 覆盖默认的 Content-Type
    }
  });
}

//导入更新变量
export function importUpdateVariablesByFile(data) {
  const formData = new FormData();
  
  // 添加文件和其他参数到 FormData
  if (data.file) {
    formData.append('file', data.file);
  }
  if (data.slave_id) {
    formData.append('slave_id', data.slave_id);
  }
  if (data.template_id) {
    formData.append('template_id', data.template_id);
  }
  if (data.company_id) {
    formData.append('company_id', data.company_id);
  }

  formData.append('lang', localStorage.getItem('lang') !=null ? localStorage.getItem('lang') : 'zh-CN'  );
   
  

  return request({
    url: '/api/variable/importupdatedisplayname',
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data' // 覆盖默认的 Content-Type
    }
  });
}

export function updateVariable(data) {
  data.lang = localStorage.getItem('lang') !=null ? localStorage.getItem('lang') : 'zh-CN'  
  return request({
    url: '/api/variable/edit',
    method: 'post',
    data
  })
}

export function deleteVariableById(data) {
  data.lang = localStorage.getItem('lang') !=null ? localStorage.getItem('lang') : 'zh-CN'  
  return request({
    url: '/api/variable/delete',
    method: 'post',
    data
  })
}
 
 
export function getDataTypes(data) {
  return request({
    url: '/api/variable/getVarDataTypes',
    method: 'post',
    data
  })
}
 
export function getRwTypes(data) {
  return request({
    url: '/api/variable/getVarRwTypes',
    method: 'post',
    data
  })
}
  
export function getStorageTypes(data) {
  return request({
    url: '/api/variable/getVarStorageTypes',
    method: 'post',
    data
  })
}
  
export function getVarTypes(data) {
  return request({
    url: '/api/variable/getVarTypes',
    method: 'post',
    data
  })
}
  
export async function fetchVariableOptions() {
  try {

    const formData = {
      pageNum: 1,
      pageSize: 1000,
      lang: localStorage.getItem('lang') !=null ? localStorage.getItem('lang') : 'zh-CN'        
    }

    const dataTypes = await getDataTypes(formData);
    const rwTypes = await getRwTypes(formData);
    const storageTypes = await getStorageTypes(formData);
    const varTypes = await getVarTypes(formData);
    const protocolTypes = await getProtocols(formData);

    return {
      dataTypes: dataTypes.data,
      rwTypes: rwTypes.data,
      storageTypes: storageTypes.data,
      varTypes: varTypes.data,
      protocolTypes: protocolTypes.data
    };
  } catch (error) {
    console.error('Error fetching variable options:', error);
    throw error; // 重新抛出错误，以便调用者可以处理
  }
}


/*
export function fetchVariableOptions() {
  return Promise.all([
    getDataTypes({}),
    getRwTypes({}),
    getStorageTypes({}),
    getVarTypes({}),
    getProtocols({})
  ]).then(([dataTypes, rwTypes, storageTypes, varTypes,protocolTypes]) => {
    return {
      dataTypes: dataTypes.data,
      rwTypes: rwTypes.data,
      storageTypes: storageTypes.data,
      varTypes: varTypes.data,
      protocolTypes:protocolTypes.data,
    }
  })
}*/